import { relativeEfficiency } from '../../../src/features/cron-calculator/cron-calculator-math.js';
import { el, fmt } from './dom.js';

// Comparação lado a lado. A oferta de maior Cron/Pérola é a referência e a
// diferença das demais é mostrada em percentual de Crons por Pérola.
export function renderPackageComparison(host, packages) {
  host.hidden = packages.length < 2;
  if (host.hidden) return host.replaceChildren();
  const ranked = [...packages].sort((a, b) => b.cronPerPearl - a.cronPerPearl);
  const best = ranked[0];
  const cards = packages.map((item) => el('article', { className: `mc-compare-card${item.id === best.id ? ' is-best' : ''}` }, [
    item.id === best.id ? el('span', { className: 'mc-compare-flag', text: 'Mais eficiente' }) : null,
    el('h3', { text: item.packageName }),
    el('p', { className: 'mc-muted', text: fmt.date(item.purchasedAt) }),
    el('dl', {}, [
      el('dt', { text: 'Pérolas pagas' }), el('dd', { text: fmt.int(item.effectivePearls) }),
      el('dt', { text: 'Crons' }), el('dd', { text: fmt.int(item.totalCrons) }),
      el('dt', { text: 'Cron/Pérola' }), el('dd', { className: 'mc-compare-cpp', text: fmt.cpp(item.cronPerPearl) }),
      el('dt', { text: 'Pérolas / 1.000 Crons' }), el('dd', { text: item.pearlsPer1000Crons ? fmt.int(item.pearlsPer1000Crons) : '—' })
    ])
  ]));
  const sentences = ranked.slice(1).map((other) => {
    const difference = relativeEfficiency(best.cronPerPearl, other.cronPerPearl);
    if (difference === null) return el('li', { text: `${other.packageName} não gerou Crons extraídas.` });
    if (Math.abs(difference) < 0.05) return el('li', { text: `${best.packageName} e ${other.packageName} têm a mesma eficiência.` });
    return el('li', {}, [el('strong', { text: best.packageName }), ' entrega aproximadamente ', el('strong', { text: fmt.pct(difference) }), ` mais Crons por Pérola que ${other.packageName}.`]);
  });
  host.replaceChildren(
    el('div', { className: 'section-head' }, [el('div', {}, [el('h2', { text: 'Comparação' }), el('p', { text: `${packages.length} ofertas lado a lado` })])]),
    el('div', { className: 'mc-compare-grid' }, cards),
    el('ul', { className: 'mc-compare-summary' }, sentences)
  );
  host.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
